import * as React from "react"
import {useEffect} from "react"
import {useSignal} from "@preact/signals-react";
import {useValidatorSeeker} from "@ui-seeker/app"
import {AccordionSeeker} from "@ui-seeker/core";
import {Grid} from "@mui/material";
import {object, string} from "yup"

import {
	UnmatchedNewProductsBrandAutocomplete,
	UnmatchedNewProductsCountryAutocomplete,
	UnmatchedNewProductsCustomerAutocomplete,
	UnmatchedNewProductsDateRangeSelect,
	UnmatchedNewProductsRetailerAutocomplete
} from "../@components";
import NewProductsFiltersBlockFooter from "./Footer";
import {customerID, disabledSubmitNewProducts, resetNewProductsFilers} from "../@signals";

export default function UnmatchedNewProductsFiltersBlock() {

    const isOpen = useSignal(true)
    const filterProps = {
        title: "Filters",
        TransitionProps: { unmountOnExit: false },
        expanded: isOpen.value,
        onChange: () => {
            isOpen.value = !isOpen.value
        },
        footerActions: <NewProductsFiltersBlockFooter />
    }

    const { isValid, errors } = useValidatorSeeker({
		customerID: customerID.value
		}, object({
			customerID: string().required("Customer is required")
		})
	)

    useEffect(() => {
        disabledSubmitNewProducts.value = !isValid
    }, [isValid])

    useEffect(() => {
        return () => {
            resetNewProductsFilers()
            disabledSubmitNewProducts.value = false
        }
    }, []);

    return <AccordionSeeker {...filterProps}>
        <Grid container spacing={2}>
            <Grid item xs={4}>
                <UnmatchedNewProductsDateRangeSelect />
            </Grid>

            <Grid item xs={4}>
                <UnmatchedNewProductsCustomerAutocomplete error={errors?.customerID} />
            </Grid>

            <Grid item xs={4}>
                <UnmatchedNewProductsCountryAutocomplete />
            </Grid>

            <Grid item xs={4}>
                <UnmatchedNewProductsRetailerAutocomplete />
            </Grid>

            <Grid item xs={4}>
                <UnmatchedNewProductsBrandAutocomplete />
            </Grid>
        </Grid>
    </AccordionSeeker>
}